import React from 'react';
import classes from '../sixYardBreif/sixYardBreif.module.css';
import Title from "../../containers/title/title";

const Mission = ({mission}) => {
    return (
        <div className={classes.Container}>
            <Title title={mission?.title} />
            <div className={classes.Description}>
                <p>{mission?.description}</p>
            </div>
        </div>
    )
}
export default Mission;